
// document.addEventListener("DOMContentLoaded", () => {
//   if (window.innerWidth > 768) return;
  
//   const stickyContainer = document.getElementById("ls_buy_button");
//   let lastScrollY = window.scrollY;
//   let isSticky = false;

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//      const currentScrollY = window.scrollY;

//       if (entry.isIntersecting) {
//         // Блок з'явився в області видимості
//         if (currentScrollY > lastScrollY && !isSticky) {
//           stickyContainer.classList.add("sticky-active");
//           isSticky = true;
//         }
//       } else {
//         // Блок вийшов за межі екрану (тільки коли скролимо вверх)
//         if (currentScrollY < lastScrollY) {
//           stickyContainer.classList.remove("sticky-active");
//           isSticky = false;
//         }
//       }

//       lastScrollY = currentScrollY;
//     },
//     { threshold: 1 }
//   );

//   observer.observe(stickyContainer);
// });



// document.addEventListener("DOMContentLoaded", () => {
//   if (window.innerWidth > 768) return;
  
//   const stickyContainer = document.getElementById("ls_buy_button");

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       if (entry.isIntersecting) {
//         stickyContainer.classList.remove("sticky-active");
//       } else {
//         stickyContainer.classList.add("sticky-active");
//       }
//     },
//     { threshold: 1 }
//   );

//   observer.observe(stickyContainer);
// });


// document.addEventListener("DOMContentLoaded", () => {
//   if (window.innerWidth > 768) return;

//   const stickyContainer = document.getElementById("ls_buy_button");

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       const isVisible = entry.isIntersecting && entry.boundingClientRect.top > 0;

//       if (isVisible) {
//         stickyContainer.classList.remove("sticky-active");
//       } else {
//         stickyContainer.classList.add("sticky-active");
//       }
//     },
//     { threshold: 0.1 }
//   );

//   observer.observe(stickyContainer);
// });

// document.addEventListener("DOMContentLoaded", () => {
//   if (window.innerWidth > 768) return;

//   const stickyContainer = document.getElementById("ls_buy_button");
//   let lastScrollY = window.scrollY;
//   let hasReachedStickyPoint = false;

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       if (entry.isIntersecting) {
//         // Юзер дійшов до місця — перестає бути sticky
//         hasReachedStickyPoint = true;
//         stickyContainer.classList.remove("sticky-active");
//       } else {
//         // Юзер ще не дійшов або вже проскролив назад
//         hasReachedStickyPoint = false;
//       }
//     },
//     { threshold: 0.6 } // 60% блока має бути видно
//   );

//   observer.observe(stickyContainer);

//   window.addEventListener("scroll", () => {
//     const currentScrollY = window.scrollY;

//     const isScrollingUp = currentScrollY < lastScrollY;

//     if (isScrollingUp && !stickyContainer.classList.contains("sticky-active")) {
//       // Якщо скролимо вгору — робимо кнопки sticky
//       stickyContainer.classList.add("sticky-active");
//     }

//     if (!isScrollingUp && hasReachedStickyPoint) {
//       // Якщо скролимо вниз і ми вже в зоні, де кнопки мають бути статичними
//       stickyContainer.classList.remove("sticky-active");
//     }

//     lastScrollY = currentScrollY;
//   });
// });


// document.addEventListener("DOMContentLoaded", () => {
//   if (window.innerWidth > 768) return;

//   const stickyContainer = document.getElementById("ls_buy_button");
//   let lastScrollY = window.scrollY;
//   let isAboveStickyPoint = true;

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       // Якщо кнопки повністю в полі зору — ми "на місці"
//       if (entry.isIntersecting) {
//         isAboveStickyPoint = false;
//         stickyContainer.classList.remove("sticky-active");
//       } else {
//         isAboveStickyPoint = true;
//       }
//     },
//     {
//       root: null,
//       threshold: 0.1,
//     }
//   );

//   observer.observe(stickyContainer);

//   window.addEventListener("scroll", () => {
//     const currentScrollY = window.scrollY;
//     const isScrollingUp = currentScrollY < lastScrollY;

//     if (isAboveStickyPoint && isScrollingUp) {
//       // Юзер проскролив вище кнопок — закріпити
//       stickyContainer.classList.add("sticky-active");
//     }

//     lastScrollY = currentScrollY;
//   });
// });

// document.addEventListener("DOMContentLoaded", () => {
//   if (window.innerWidth > 768) return;

//   const stickyBlock = document.getElementById("ls_buy_button");
//   const buyButtons = stickyBlock.querySelector(".buy-buttons");
//   let lastScrollY = window.scrollY;

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       const scrollingUp = window.scrollY < lastScrollY;

//       if (entry.isIntersecting) {
//         // Коли ми дійшли до блоку — знімаємо fixed
//         buyButtons.classList.add("static");
//       } else if (scrollingUp) {
//         // Коли юзер йде вгору і кнопки вже не видно — повертаємо fixed
//         buyButtons.classList.remove("static");
//       }

//       lastScrollY = window.scrollY;
//     },
//     {
//       threshold: 0.5,
//     }
//   );

//   observer.observe(stickyBlock);
// });



// document.addEventListener("DOMContentLoaded", () => {
//   if (window.innerWidth > 768) return;

//   const stickyBlock = document.getElementById("ls_buy_button");
//   const buyButtons = stickyBlock.querySelector(".buy-buttons");

//   let lastScrollY = window.scrollY;
//   let isStuck = false;

//   function updateStickyState() {
//     const rect = stickyBlock.getBoundingClientRect();
//     const scrollingUp = window.scrollY < lastScrollY;

//     const inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
//     const passedBelow = rect.top < window.innerHeight && rect.bottom > 0;

//     if (passedBelow && !scrollingUp) {
//       // Коли ми знаходимося в області кнопки і йдемо вниз — встають на місце
//       buyButtons.classList.add("static");
//       isStuck = true;
//     } else if (scrollingUp && rect.bottom < window.innerHeight) {
//       // Коли піднімаємося вгору і кнопки вже вище — знову їдуть
//       buyButtons.classList.remove("static");
//       isStuck = false;
//     }

//     lastScrollY = window.scrollY;
//   }

//   // IntersectionObserver — для плавності
//   const observer = new IntersectionObserver(updateStickyState, {
//     threshold: [0, 0.25, 0.5, 0.75, 1],
//   });

//   observer.observe(stickyBlock);

//   // Страховка на кожен scroll
//   window.addEventListener("scroll", updateStickyState);
// });


// document.addEventListener("DOMContentLoaded", () => {
//   if (window.innerWidth > 768) return;

//   const stickyBlock = document.getElementById("ls_buy_button");
//   const buyButtons = stickyBlock.querySelector(".buy-buttons");
//   let lastScrollY = window.scrollY;
//   let isSticky = false;

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       const currentScrollY = window.scrollY;
//       const scrollingDown = currentScrollY > lastScrollY;
//       const scrollingUp = currentScrollY < lastScrollY;

//       if (entry.isIntersecting && scrollingDown && !isSticky) {
//         buyButtons.classList.add("static");
//         isSticky = true;
//       } else if (!entry.isIntersecting && scrollingUp && isSticky) {
//         buyButtons.classList.remove("static");
//         isSticky = false;
//       }

//       lastScrollY = currentScrollY;
//     },
//     {
//       threshold: 0.1, // дозволяє легше зловити перетин
//     }
//   );

//   // Фікс для ситуації, коли сторінка відкрилась вже прокрученою
//   const checkInitialPosition = () => {
//     const rect = stickyBlock.getBoundingClientRect();
//     if (rect.top < window.innerHeight && rect.bottom > 0) {
//       buyButtons.classList.add("static");
//       isSticky = true;
//     } else {
//       buyButtons.classList.remove("static");
//       isSticky = false;
//     }
//   };

//   observer.observe(stickyBlock);
//   window.addEventListener("load", checkInitialPosition);
//   window.addEventListener("scroll", () => {
//     // Підстраховка, якщо IntersectionObserver щось пропустить
//     if (!stickyBlock || !buyButtons) return;

//     const rect = stickyBlock.getBoundingClientRect();
//     if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
//       buyButtons.classList.add("static");
//     }
//   });
// });


// document.addEventListener("DOMContentLoaded", () => {
//   if (window.innerWidth > 768) return;

//   const stickyBlock = document.getElementById("ls_buy_button");
//   const buyButtons = stickyBlock.querySelector(".buy-buttons");

//   let lastScrollY = window.scrollY;
//   let isSticky = false;

//   const handleSticky = (entry) => {
//     const currentScrollY = window.scrollY;
//     const scrollingDown = currentScrollY > lastScrollY;
//     const scrollingUp = currentScrollY < lastScrollY;

//     const blockTop = stickyBlock.getBoundingClientRect().top;

//     // === ВСТАЄ НА МІСЦЕ (при скролі вниз і перетині) ===
//     if (entry.isIntersecting && scrollingDown && !isSticky) {
//       buyButtons.classList.add("static");
//       isSticky = true;
//     }

//     // === ПОЧИНАЄ ЇХАТИ ЗНОВУ (при скролі вверх і блок вже не видимий) ===
//     if (!entry.isIntersecting && scrollingUp && isSticky) {
//       buyButtons.classList.remove("static");
//       isSticky = false;
//     }

//     // === ДОДАТКОВА ПІДСТРАХОВКА — якщо скролим вверх і блок ще видимий, але юзер вище його
//     if (scrollingUp && blockTop > window.innerHeight && isSticky) {
//       buyButtons.classList.remove("static");
//       isSticky = false;
//     }

//     lastScrollY = currentScrollY;
//   };

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       handleSticky(entry);
//     },
//     { threshold: 0.1 }
//   );

//   observer.observe(stickyBlock);

//   // Перевірка після завантаження (страховка)
//   window.addEventListener("load", () => {
//     const rect = stickyBlock.getBoundingClientRect();
//     if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
//       buyButtons.classList.add("static");
//       isSticky = true;
//     }
//   });
// });


// document.addEventListener("DOMContentLoaded", () => {
//   if (window.innerWidth > 768) return;

//   const stickyBlock = document.getElementById("ls_buy_button");
//   const buyButtons = stickyBlock.querySelector(".buy-buttons");

//   let lastScrollY = window.scrollY;
//   let isSticky = false;
//   let firstTrigger = true;

//   const handleSticky = (entry) => {
//     const currentScrollY = window.scrollY;
//     const scrollingDown = currentScrollY > lastScrollY;
//     const scrollingUp = currentScrollY < lastScrollY;
//     const blockTop = stickyBlock.getBoundingClientRect().top;
//     const blockBottom = stickyBlock.getBoundingClientRect().bottom;

//     // === ПЕРШИЙ раз — якщо ми ВЖЕ в межах блоку ===
//     if (firstTrigger && entry.isIntersecting && blockTop >= 0 && blockBottom <= window.innerHeight) {
//       buyButtons.classList.add("static");
//       isSticky = true;
//       firstTrigger = false;
//       lastScrollY = currentScrollY;
//       return;
//     }

//     firstTrigger = false;

//     // === ВСТАЄ НА МІСЦЕ ===
//     if (entry.isIntersecting && scrollingDown && !isSticky) {
//       buyButtons.classList.add("static");
//       isSticky = true;
//     }

//     // === ПОЧИНАЄ ЇХАТИ ЗНОВУ ===
//     if (!entry.isIntersecting && scrollingUp && isSticky) {
//       buyButtons.classList.remove("static");
//       isSticky = false;
//     }

//     // === ДОДАТКОВА перевірка якщо скролимо вгору і блок нижче
//     if (scrollingUp && blockTop > window.innerHeight && isSticky) {
//       buyButtons.classList.remove("static");
//       isSticky = false;
//     }

//     lastScrollY = currentScrollY;
//   };

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       handleSticky(entry);
//     },
//     { threshold: 0.1 }
//   );

//   observer.observe(stickyBlock);

//   // Підстраховка при завантаженні
//   window.addEventListener("load", () => {
//     const rect = stickyBlock.getBoundingClientRect();
//     if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
//       buyButtons.classList.add("static");
//       isSticky = true;
//     }
//   });
// });




// document.addEventListener("DOMContentLoaded", () => {
//   if (window.innerWidth > 768) return;

//   const stickyBlock = document.getElementById("ls_buy_button");
//   const buyButtons = stickyBlock.querySelector(".buy-buttons");

//   let lastScrollY = window.scrollY;
//   let isSticky = false;

//   const handleSticky = (entry) => {
//     const currentScrollY = window.scrollY;
//     const scrollingDown = currentScrollY > lastScrollY;
//     const scrollingUp = currentScrollY < lastScrollY;
//     const blockTop = stickyBlock.getBoundingClientRect().top;

//     // Якщо блок знаходиться в межах видимості і ми скролимо вниз
//     if (entry.isIntersecting && scrollingDown && !isSticky) {
//       buyButtons.classList.add("static");
//       isSticky = true;
//     }

//     // Якщо блок не в межах видимості і ми скролимо вверх
//     if (!entry.isIntersecting && scrollingUp && isSticky) {
//       buyButtons.classList.remove("static");
//       isSticky = false;
//     }

//     // Якщо блок вже нижче екрану, а ми скролимо вверх
//     if (scrollingUp && blockTop > window.innerHeight && isSticky) {
//       buyButtons.classList.remove("static");
//       isSticky = false;
//     }

//     lastScrollY = currentScrollY;
//   };

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       handleSticky(entry);
//     },
//     { threshold: 0.1 }
//   );

//   observer.observe(stickyBlock);

//   // Підстраховка для випадку, якщо сторінка завантажена зі скролом вниз
//   window.addEventListener("load", () => {
//     const rect = stickyBlock.getBoundingClientRect();
//     if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
//       buyButtons.classList.add("static");
//       isSticky = true;
//     }
//   });
// });


document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth > 768) return;

  const stickyBlock = document.getElementById("ls_buy_button");
  const buyButtons = stickyBlock.querySelector(".buy-buttons");

  let lastScrollY = window.scrollY;
  let isSticky = false;

  const checkSticky = () => {
    const currentScrollY = window.scrollY;
    const blockTop = stickyBlock.getBoundingClientRect().top;
    const blockBottom = stickyBlock.getBoundingClientRect().bottom;

    // Якщо ми скролимо вниз і блок в межах екрану
    if (blockTop <= 0 && currentScrollY > lastScrollY && !isSticky) {
      buyButtons.classList.add("static");
      isSticky = true;
    }

    // Якщо скролимо вгору і блок вийшов з екрану
    if (blockTop > window.innerHeight && currentScrollY < lastScrollY && isSticky) {
      buyButtons.classList.remove("static");
      isSticky = false;
    }

    // Для перевірки першого разу (якщо блок все ще в межах екрану)
    if (blockTop >= 0 && blockBottom <= window.innerHeight && !isSticky) {
      buyButtons.classList.add("static");
      isSticky = true;
    }

    lastScrollY = currentScrollY;
  };

  // Оптимізуємо за допомогою requestAnimationFrame для плавності
  const rafHandler = () => {
    checkSticky();
    requestAnimationFrame(rafHandler);
  };

  // Запуск перевірки скролу
  rafHandler();

  // Підстраховка для випадку, якщо сторінка завантажена зі скролом вниз
  window.addEventListener("load", () => {
    const rect = stickyBlock.getBoundingClientRect();
    if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
      buyButtons.classList.add("static");
      isSticky = true;
    }
  });
});




